import {
	initFormKitSchema,
	formKitSchemaOptions,
} from 'shared/utils/initFormKitSchema';
import { track_start_page_exit_click } from 'shared/services/tracking/healthCheckTrackingService';
import store from 'shared/store';
import { createApp, defineAsyncComponent } from 'vue';
import HealthCheckTool from './HealthCheckTool.vue';
import 'shared/styles/components/_c-list-block.scss';
import './HealthCheckTool.scss';

function healthCheckToolExitHandler() {
	const healthCheckExitButton = document.querySelector(
		'.c-health-check-header__cta--exit',
	);

	if (!healthCheckExitButton) {
		return;
	}

	healthCheckExitButton.addEventListener('click', (event) => {
		event.preventDefault();

		const fallbackUrl = (healthCheckExitButton as HTMLLinkElement).href;
		const referrer = document.referrer;
		let isInternalReferrer = false;

		try {
			isInternalReferrer =
				referrer !== '' && new URL(referrer).host === window.location.host;
		} catch (error) {
			console.error('Error getting health check internal referrer:', error);
		}

		const exitUrl =
			isInternalReferrer && window.history.length > 1 ? referrer : fallbackUrl;

		if (!exitUrl) {
			return;
		}

		track_start_page_exit_click(store.getters['getCulture'], exitUrl);
		window.location.href = exitUrl;
	});
}

async function mountHealthCheckTool() {
	const healthCheckTool = document.getElementById('health-check-tool');

	if (!healthCheckTool) {
		console.warn('[HealthCheckTool] Container not found');
		return;
	}

	const options = await formKitSchemaOptions();
	const app = createApp({
		name: 'HealthCheckToolApp',
	});
	app.component('health-check-tool', HealthCheckTool);
	app.component(
		'checkout-modal-login',
		defineAsyncComponent(
			() =>
				import(
					/* webpackChunkName: "checkout-modal-login" */ 'multisite/components/checkout/checkoutModalLogin.vue'
				),
		),
	);
	app.component(
		'references-list',
		defineAsyncComponent(
			() =>
				import(
					/* webpackChunkName: "references-list" */ 'shared/components/ReferencesList.vue'
				),
		),
	);
	app.component(
		'form-kit-builder-container',
		defineAsyncComponent(
			() =>
				import('shared/components/FormKitBuilderContainer/FormKitBuilderContainer.vue'),
		),
	);
	await initFormKitSchema(app, options);
	app.use(store);
	app.mount(healthCheckTool);
}

mountHealthCheckTool().catch((error) => {
	console.error('Error mounting HealthCheckTool:', error);
});
healthCheckToolExitHandler();

